module.exports = __webpack_public_path__ + "img/left_7_hover.7b17d592.png";